import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var Glyphicon = require("components/utility/icons/Glyphicon");

@connect(
  (state, props) => ({
    teacherComments: WritingSelectors.comments({
      state,
      filters: {
        subject_type: "JournalActivityAnswer",
        subject_id: props.answer.id + ""
      }
    })
  }),
  (dispatch, props) => ({
    populateData: () => dispatch(WritingActions.fetchComments({
      filters: {
        subject_type: "JournalActivityAnswer",
        subject_id: props.answer.id + "",
        subject_user_id: props.answer.user_id
      },
      embeds: ["comment.user"],
      cache: true
    }))
  })
)
@providePopulateData()
class StandaloneEssayRevisionTile extends React.Component {
  render() {
    const { answer, teacherComments, onRevisionClick } = this.props;
    var imgPath = require("action-icons/essays.png");

    // Sort comments newest-first and take the most recent teacher comment
    var sortedComments = _.sortBy(teacherComments || [], c => -new Date(c.created_at).getTime());
    var latestFeedback = _.first(sortedComments);

    return (
      <div
        className="revisionTask"
        data-item-type="essay"
        data-answer-id={answer.id}
        onClick={onRevisionClick}
      >
        <span className="revisionBadge">Revision</span>
        <img src={imgPath} alt="Revise your essay" />
        <div className="taskTitle">
          {answer.question_text || "Essay Revision"}
        </div>
        {latestFeedback && (
          <div className="teacherFeedbackPreview">
            <span className="feedbackHeader">
              <Glyphicon icon="comment" className="feedbackIcon" />
              {" Teacher Feedback"}
            </span>
            <p className="feedbackBody">&ldquo;{latestFeedback.body}&rdquo;</p>
            {latestFeedback.user && (
              <span className="feedbackAuthor">&mdash; {latestFeedback.user.display_name}</span>
            )}
          </div>
        )}
      </div>
    );
  }
}

StandaloneEssayRevisionTile.WrappedComponent.propTypes = StrictPropTypes({
  answer: PropTypes.object.isRequired,
  onRevisionClick: PropTypes.func.isRequired,
  // from @connect
  teacherComments: PropTypes.array,
  // from @connect dispatch
  populateData: PropTypes.func,
});

module.exports = StandaloneEssayRevisionTile;



// WEBPACK FOOTER //
// ./modules/components/users/students/StandaloneEssayRevisionTile.js